import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

/**
 * Normalizes values from native text-like inputs when the user leaves a field.
 * Dispatching `input` lets Angular update both ngModel and reactive controls.
 */
@Injectable({ providedIn: 'root' })
export class InputTrimService {
    private readonly trimmableTypes = new Set([
        'email',
        'search',
        'tel',
        'text',
        'url'
    ]);

    constructor(@Inject(DOCUMENT) private readonly document: Document) {
        // Capture runs before Angular's own blur handler, including controls
        // configured with updateOn: 'blur'.
        this.document.addEventListener('blur', this.trimValue, true);
    }

    private trimValue = (event: FocusEvent): void => {
        const input = event.target;

        if (!(input instanceof HTMLInputElement)
            || !this.trimmableTypes.has(input.type)
            || input.dataset['preserveWhitespace'] !== undefined) {
            return;
        }

        const trimmedValue = input.value.trim();
        if (trimmedValue === input.value) {
            return;
        }

        input.value = trimmedValue;
        input.dispatchEvent(new Event('input', { bubbles: true }));
    };
}
